export default __webpack_public_path__ + "f3b3ce69da7e2d583d6e2db424b21577.svg";